import { create } from 'zustand'
import api from '../apis/api'

export const useAlertsStore = create((set) => ({
    alerts: [],
    get_alerts: async(sites, status) => {
        return api.post('/alerts', {siteId: sites.join("|"), status: status.join("|")})
    },
    set_alerts: async(alerts) => {
        set({alerts: alerts})
    }
}))